import React, { useEffect, useState } from 'react';
import '../styles/Onboarding.css';
import Polygon from '../images/Polygon_1.png';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/store.js';
import { getFullName } from '../api/user.js';
import { useQuery } from '@tanstack/react-query';
import { useWindowDimensions } from '../helpers/screenDimensions.js';
import { TiArrowSortedUp } from 'react-icons/ti';

export const InitialOnboarding = () => {
    const location = useLocation();
    const [counter, setCounter] = useState(0);
    const { width } = useWindowDimensions();
    const uid = useAuthStore(store => store.user?.uid);
    const navigate = useNavigate();
    const [username, setUsername] = useState('');

    const prompts = [
        'Welcome, ' + username + '! I\'m your Wellness Buddy.',
        'Together, we will customize my appearance to suit your preferences.',
        'I\'m here to support your mental health and wellbeing.',
        'Let\'s embark on this journey towards a healthier, happier you!',
    ];
    function handleClick() {
        const history = location.state?.history ?? [];
        navigate('/avatar', { state: { history: [...history, '/onboard'] } });
    };

    const getUserFullNameQuery = useQuery({
        queryKey: ['getFullName', uid],
        queryFn: () => getFullName(uid),
        enabled: !(uid === null || uid === undefined),
    });

    useEffect(() => {
        if (getUserFullNameQuery.data !== null && getUserFullNameQuery.isSuccess) {
            setUsername(getUserFullNameQuery.data);
        }
    }, [getUserFullNameQuery.data, getUserFullNameQuery.isSuccess, width]);

    useEffect(() => {
        if (width < 768) {
            document.getElementsByClassName('ready-btn')[0].setAttribute('disabled', '');
        }
    }, [width]);

    function handleNext() {
        if (counter === prompts.length - 1) {
            document.getElementsByClassName('arrow')[0].classList.add('hide');
            document.getElementsByClassName('ready-btn')[0].removeAttribute('disabled');
        }
        if (counter < prompts.length - 1) {
            setCounter(counter + 1);
            document.getElementsByClassName('onboarding-text')[0].classList.add('animations');
        }
    }

    return (
        <div className='outside-container flex w-90 h-75 m-5 items-center justify-center border-1 border-green border-solid gap-2 py-10 px-7.5 bg-onboardBackground
        min-w-500'>
            <img src={Polygon} className='polygon w-60 h-60 sm:w-40 sm:h-40 xs:w-30 xs:h-30' alt='Polygon-image'>
            </img>
            <div className='w-100 h-60 block text-center'>
                <div className='message-box w-100 h-60 bg-onboardMessageBox rounded-4xl xl:py-10 lg:px-2 lg:py-9  md:py-8 md:px-4 md:leading-5 sm:h-40 sm:mt-10 xs:h-30 xs:mt-15 shadow-md outline-none'>
                    {width < 769
                        ? <div className='container-mobile grid relative'>
                            <div className='onboarding-container sm:py-4 sm:px-8 xs:py-4 xs:px-4'>
                                <p className='onboarding-text animate-fadeIn xs:text-xs'>{prompts[counter]}</p>
                            </div>
                            <div className='arrow-container'>
                                <TiArrowSortedUp
                                    className='arrow h-6 w-6 rotate-90 absolute right-0 bottom-2 items-end pointer-events-auto z-3'
                                    onClick={() => handleNext()}>
                                </TiArrowSortedUp>
                            </div>
                        </div>
                        : prompts.map((item, index) => {
                            return (<p key={index} className='onboarding-text text-4 animate-fadeIn'> {item} </p>);
                        })
                    }
                </div>
                <button className='ready-btn mt-6 w-40 h-12 text-base uppercase tracking-base font-bold bg-white border-none rounded-2xl p-3 z-3 pointer-events-auto shadow-base outline-none xs:w-32 z-3' onClick={() => handleClick()}>
                    <p className='ready-btn-text text-base xs:text-xs'>Im Ready! </p>
                </button>
            </div>
        </div>
    );
};
